import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
const imgPath = '/i3/saas_templates/shopiko/';

const BG = [
	{
		name: 'Venus',
		img: imgPath + 'Venus.jpg',
		href: 'https://venus.shopiko.bg'
	},
	{
		name: 'Minimal',
		img: imgPath + 'Minimal.jpg',
		href: 'https://minimal.shopiko.bg'
	},
	{
		name: 'Twinkle',
		img: imgPath + 'Twinkle.jpg',
		href: 'https://twinkles.shopiko.bg'
	},
	{
		name: 'SimpleElegance',
		img: imgPath + 'SimpleElegance.jpg',
		href: 'https://simpleelegance.shopiko.bg'
	},
	{
		name: 'Noble',
		img: imgPath + 'Noble.jpg',
		href: 'https://noble.shopiko.bg'
	},
	{
		name: 'Next & Co.',
		img: imgPath + 'NextCo.jpg',
		href: 'https://nextco.shopiko.bg'
	},
	{
		name: 'Techno',
		img: imgPath + 'Techno.jpg',
		href: 'https://techno.shopiko.bg'
	},
	{
		name: 'Iris',
		img: imgPath + 'Iris.jpg',
		href: 'https://iris.shopiko.bg'
	},
	{
		name: 'Vertigo',
		img: imgPath + 'Vertigo.jpg',
		href: 'https://vertigo.shopiko.bg'
	},
	{
		name: 'Solid Colors',
		img: imgPath + 'SolidColors.jpg',
		href: 'https://solidcolors.shopiko.bg'
	},
	{
		name: 'Vintage',
		img: imgPath + 'Vintage.jpg',
		href: 'https://vintage.shopiko.bg'
	},
	{
		name: 'Organic',
		img: imgPath + 'Organic.jpg',
		href: 'https://organic.shopiko.bg'
	},
	{
		name: 'Classic',
		img: imgPath + 'Classic.jpg',
		href: 'https://classic.shopiko.bg'
	},
	{
		name: 'Electro',
		img: imgPath + 'Electro.jpg',
		href: 'https://electro.shopiko.bg'
	},
];

///////////////////////////////////////////////////////////////////////////////////////////

const EN = [
	{
		name: 'Venus',
		img: imgPath + 'Venus.jpg',
		href: 'https://venus.shopiko.bg'
	},
	{
		name: 'Minimal',
		img: imgPath + 'Minimal.jpg',
		href: 'https://minimal.shopiko.bg'
	},
	{
		name: 'Twinkle',
		img: imgPath + 'Twinkle.jpg',
		href: 'https://twinkles.shopiko.bg'
	},
	{
		name: 'SimpleElegance',
		img: imgPath + 'SimpleElegance.jpg',
		href: 'https://simpleelegance.shopiko.bg'
	},
	{
		name: 'Noble',
		img: imgPath + 'Noble.jpg',
		href: 'https://noble.shopiko.bg'
	},
	{
		name: 'Next & Co.',
		img: imgPath + 'NextCo.jpg',
		href: 'https://nextco.shopiko.bg'
	},
	{
		name: 'Techno',
		img: imgPath + 'Techno.jpg',
		href: 'https://techno.shopiko.bg'
	},
	{
		name: 'Iris',
		img: imgPath + 'Iris.jpg',
		href: 'https://iris.shopiko.bg'
	},
	{
		name: 'Vertigo',
		img: imgPath + 'Vertigo.jpg',
		href: 'https://vertigo.shopiko.bg'
	},
	{
		name: 'Solid Colors',
		img: imgPath + 'SolidColors.jpg',
		href: 'https://solidcolors.shopiko.bg'
	},
	{
		name: 'Vintage',
		img: imgPath + 'Vintage.jpg',
		href: 'https://vintage.shopiko.bg'
	},
	{
		name: 'Organic',
		img: imgPath + 'Organic.jpg',
		href: 'https://organic.shopiko.bg'
	},
	{
		name: 'Classic',
		img: imgPath + 'Classic.jpg',
		href: 'https://classic.shopiko.bg'
	},
	{
		name: 'Electro',
		img: imgPath + 'Electro.jpg',
		href: 'https://electro.shopiko.bg'
	},
];

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];